// extracted by mini-css-extract-plugin
export var calendarView = "_63-0";